<template>
    <div class="navBar">
        <div class="navBar__logo">
            <img src="@\assets\logo-fundacion-forge-footer-color.png" alt="">
        </div>
        <div class="navBar__icons">
            <i class="material-icons navbar__icon">notifications</i>
            <i class="material-icons navbar__icon" @click="toggleMenu">account_circle</i>
        </div>
    </div>
    
</template>

<script>
export default {
    setup(_, {emit}) {

        function toggleMenu() {
            emit('openUserMenu');
        }

        return {
            toggleMenu,
        }

    }
    
}
</script>

<style lang="scss" scoped>
    .navBar{
        width: 100%;
        height: 56px;
        padding: 0 $margin-mega;
        position: sticky;
        top: 0;
        z-index: 16;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: $white;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        &__logo{
            height: 60%;
            img{
                height: 100%;
                object-fit: contain;
            }
        }
        &__icons{
            display: flex;
            color: $gray;
            cursor: pointer;
            :first-child{
                margin-right: $margin-base;
                cursor: default;
                opacity: .5;
            }
        }
    }

</style>